import React, { useState } from "react";
import { logout } from "../../resources/api.resource";
import {
  styled,
  Avatar,
  Badge,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';

interface UserActionsProps {
  type: "direct" | "group" | "channel" | "project";
  groupId: string;
  onOpenDrawer: (type: string) => void;
}

const StyledBadge = styled(Badge)(() => ({
  '& .MuiBadge-badge': {
    backgroundColor: '#44b700',
    color: '#44b700',
    boxShadow: `0 0 0 2px transparent`,
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    minWidth: '10px',
  },
}));

const UserActions: React.FC<UserActionsProps> = ({ onOpenDrawer }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    handleMenuClose();
    const response = await logout();
    if (response?.logoutUrl) {
      window.location.href = response.logoutUrl;
    }
  };

  return (
    <>
      <StyledBadge
        overlap="circular"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}

        onClick={() => onOpenDrawer('files')}
        sx={{ cursor: 'pointer' }}>
        <Avatar>
          <AttachFileIcon />
        </Avatar>
      </StyledBadge>
      <StyledBadge
        overlap="circular"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        onClick={() => onOpenDrawer('users')}
        sx={{ cursor: 'pointer' }}>
        <Avatar>
          <GroupAddIcon />
        </Avatar>
      </StyledBadge>
      <Avatar
        onClick={handleMenuOpen}
        sx={{ cursor: 'pointer', width: 40, height: 40 }}
      >
        <PersonIcon />
      </Avatar>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <LogoutIcon fontSize="small" sx={{ color: 'error.main' }} />
          </ListItemIcon>
          <ListItemText primary="Log out" sx={{ color: 'error.main' }} />
        </MenuItem>
      </Menu>
    </>
  );
};

export default UserActions;
